import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import type { QuoteAnalyticsSummary } from '@/models/quoteAnalytics'
import { TimeToQuotingCard } from './TimeToQuotingCard'

const pct = (n: number) => `${(n * 100).toFixed(1)}%`

export function FunnelTab({ summary }: { summary: QuoteAnalyticsSummary }) {
  const f = summary.funnel
  const stages = [
    { label: 'Estimates', value: f.estimates },
    { label: 'Indications', value: f.indications },
    { label: 'Quotes', value: f.quotes },
    { label: 'Bound', value: f.bound },
  ]
  const top = Math.max(...stages.map((s) => s.value), 1)
  return (
    <div className="flex flex-col gap-6 pt-4">
      <Card>
        <CardHeader>
          <CardTitle>Conversion funnel</CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col gap-2">
          {stages.map((s, i) => (
            <div key={s.label} className="grid grid-cols-[7rem_1fr_auto] items-center gap-3">
              <div className="text-sm text-neutral-500">{s.label}</div>
              <div className="h-6 overflow-hidden rounded bg-neutral-100 dark:bg-neutral-800">
                <div
                  className="h-full rounded bg-indigo-500"
                  style={{ width: `${(s.value / top) * 100}%` }}
                />
              </div>
              <div className="text-sm whitespace-nowrap tabular-nums">
                {s.value}
                {i > 0 && stages[i - 1].value ? ` (${pct(s.value / stages[i - 1].value)})` : ''}
              </div>
            </div>
          ))}
        </CardContent>
      </Card>

      <TimeToQuotingCard timeToQuoting={summary.timeToQuoting} />

      <Card>
        <CardHeader>
          <CardTitle>Vendor win rate</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Vendor / carrier</TableHead>
                <TableHead className="text-right">Quotes</TableHead>
                <TableHead className="text-right">Bound</TableHead>
                <TableHead className="text-right">Win rate</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {summary.winRate.map((r, i) => (
                <TableRow key={i}>
                  <TableCell>{r.carrier}</TableCell>
                  <TableCell className="text-right">{r.quotes}</TableCell>
                  <TableCell className="text-right">{r.bound}</TableCell>
                  <TableCell className="text-right">{pct(r.winRate)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  )
}
